import { render } from "./HistoryChart.vue?vue&type=template&id=4cfcdc86"
import script from "./HistoryChart.vue?vue&type=script&lang=js"
export * from "./HistoryChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__